import * as XLSX from "xlsx";

export const handleExportToExcel = (rows, typeName, sheetName) => {
  const worksheet = XLSX.utils.json_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, `${typeName}`);
  XLSX.writeFile(workbook, `${sheetName}.xlsx`);
};

